import React from "react";
import Layout from "Layout";
import Section from "Layout/Section";
import BulkUploadJobsComponent from "components/BulkBundleUtility/BulkUploadJobs/index";

const BulkUploadJobs = () => {
  return (
    <Layout>
      <Section>
       <BulkUploadJobsComponent />
      </Section>
    </Layout>
  );
};

export default BulkUploadJobs;
